function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1980(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27.42,
    height: 13.19,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8842857142857141
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 6.595
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.19,
    width: 27.42,
    height: 19.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.9875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 23.165
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.14,
    width: 27.42,
    height: 20.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 43.19
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 53.24,
    width: 27.42,
    height: 27.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.742
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 66.98
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.71,
    width: 27.42,
    height: 33.38,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.484
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 97.39999999999999
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.09,
    width: 27.42,
    height: 33.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.484
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 131.035
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 147.98,
    width: 27.42,
    height: 34.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 165.065
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 182.14,
    width: 27.42,
    height: 34.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 199.54
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 216.94,
    width: 27.42,
    height: 34.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.484
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 234.415
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 251.89,
    width: 27.42,
    height: 35.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 269.505
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 287.13,
    width: 27.42,
    height: 36.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.046666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 305.355
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 323.57,
    width: 27.42,
    height: 36.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9171428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 341.875
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 360.19,
    width: 27.42,
    height: 41.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.046666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 380.935
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 401.68,
    width: 27.42,
    height: 44.55,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 423.955
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 446.23,
    width: 27.42,
    height: 48.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.742
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 470.475
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 494.72,
    width: 27.42,
    height: 49.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 519.33
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 543.95,
    width: 27.42,
    height: 49.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.484
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 568.9000000000001
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 593.84,
    width: 27.42,
    height: 52.27,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 619.975
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 646.12,
    width: 27.42,
    height: 53.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.71,
    y: 673.0600000000001
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 0,
    width: 34.56,
    height: 42.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.7,
    y: 21.415
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.98,
    y: 0,
    width: 34.71,
    height: 42.83,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.335,
    y: 21.415
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.68,
    y: 0,
    width: 35.6,
    height: 42.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.085714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.48,
    y: 21.415
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.28,
    y: 0,
    width: 36.8,
    height: 42.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.257142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.68,
    y: 21.415
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.08,
    y: 0,
    width: 37.34,
    height: 42.83,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.75,
    y: 21.415
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.43,
    y: 0,
    width: 38.64,
    height: 42.83,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.75,
    y: 21.415
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.06,
    y: 0,
    width: 41.79,
    height: 42.83,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.22375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.955,
    y: 21.415
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.85,
    y: 0,
    width: 42.28,
    height: 42.83,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8436363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.99,
    y: 21.415
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.13,
    y: 0,
    width: 43.62,
    height: 42.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.35375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.94,
    y: 21.415
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.75,
    y: 0,
    width: 43.68,
    height: 42.83,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.565999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 394.59,
    y: 21.415
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.43,
    y: 0,
    width: 45.67,
    height: 42.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.265,
    y: 21.415
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.1,
    y: 0,
    width: 46.43,
    height: 42.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.315,
    y: 21.415
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.53,
    y: 0,
    width: 46.5,
    height: 42.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.78,
    y: 21.415
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.03,
    y: 0,
    width: 47.44,
    height: 42.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2829999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 578.75,
    y: 21.415
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.47,
    y: 0,
    width: 48.32,
    height: 42.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2829999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.63,
    y: 21.415
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.79,
    y: 0,
    width: 49.21,
    height: 42.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.395,
    y: 21.415
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 42.83,
    width: 51.65,
    height: 45.69,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.614999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 65.675
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 88.52,
    width: 51.65,
    height: 46.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 111.595
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 134.66,
    width: 51.65,
    height: 46.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 157.85999999999999
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 181.06,
    width: 51.65,
    height: 46.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 204.505
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 227.95,
    width: 51.65,
    height: 47.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 251.575
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 275.21,
    width: 51.65,
    height: 47.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.795714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 298.995
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 322.78,
    width: 51.65,
    height: 49.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.988
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 347.75
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 372.72,
    width: 51.65,
    height: 50.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.096
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 397.96000000000004
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 423.2,
    width: 51.65,
    height: 52.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 449.54499999999996
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 475.9,
    width: 51.65,
    height: 54.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.216666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 502.91499999999996
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 529.92,
    width: 51.65,
    height: 54.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.45625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 557.015
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 584.12,
    width: 51.65,
    height: 56.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.738888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 612.5
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.42,
    y: 640.88,
    width: 51.65,
    height: 59.12,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.245000000000005,
    y: 670.4399999999999
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 42.83,
    width: 54.36,
    height: 56.36,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.25,
    y: 71.00999999999999
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.43,
    y: 42.83,
    width: 56,
    height: 56.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.43,
    y: 71.00999999999999
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.43,
    y: 42.83,
    width: 60.89,
    height: 56.36,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.262222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.875,
    y: 71.00999999999999
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.32,
    y: 42.83,
    width: 61.05,
    height: 56.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.84499999999997,
    y: 71.00999999999999
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.37,
    y: 42.83,
    width: 61.2,
    height: 56.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.393333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.97,
    y: 71.00999999999999
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.57,
    y: 42.83,
    width: 61.84,
    height: 56.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.051428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.49,
    y: 71.00999999999999
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.4,
    y: 42.83,
    width: 62.03,
    height: 56.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.393333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.41499999999996,
    y: 71.00999999999999
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496.43,
    y: 42.83,
    width: 65.82,
    height: 56.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.262222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.34,
    y: 71.00999999999999
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.26,
    y: 42.83,
    width: 68.59,
    height: 56.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.051428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.555,
    y: 71.00999999999999
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.85,
    y: 42.83,
    width: 69.15,
    height: 56.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.4250000000001,
    y: 71.00999999999999
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 99.19,
    width: 66.63,
    height: 63.15,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.89375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.38499999999999,
    y: 130.765
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 162.34,
    width: 66.63,
    height: 64.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.221428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.38499999999999,
    y: 194.615
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 226.89,
    width: 66.63,
    height: 66.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.028333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.38499999999999,
    y: 259.97499999999997
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 293.07,
    width: 66.63,
    height: 66.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.049999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.38499999999999,
    y: 326.21999999999997
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 359.36,
    width: 66.63,
    height: 66.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.38499999999999,
    y: 392.6
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 425.85,
    width: 66.63,
    height: 67.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.662999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.38499999999999,
    y: 459.45500000000004
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 493.05,
    width: 66.63,
    height: 68.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.518571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.38499999999999,
    y: 527.12
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 561.19,
    width: 66.63,
    height: 69.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.518571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.38499999999999,
    y: 595.7750000000001
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.07,
    y: 630.37,
    width: 66.63,
    height: 69.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.518571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.38499999999999,
    y: 665.185
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.69,
    y: 99.19,
    width: 63.05,
    height: 74.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.508333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.215,
    y: 136.265
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 99.19,
    width: 63.53,
    height: 74.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.588333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.515,
    y: 136.265
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.27,
    y: 99.19,
    width: 67.32,
    height: 74.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.463999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.92999999999995,
    y: 136.265
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.59,
    y: 99.19,
    width: 69.08,
    height: 74.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.815999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.13,
    y: 136.265
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.67,
    y: 99.19,
    width: 69.77,
    height: 74.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.4425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.555,
    y: 136.265
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.44,
    y: 99.19,
    width: 70.08,
    height: 74.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.48,
    y: 136.265
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 548.52,
    y: 99.19,
    width: 72.53,
    height: 74.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.06625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.785,
    y: 136.265
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.04,
    y: 99.19,
    width: 78.96,
    height: 74.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.238888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.52,
    y: 136.265
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.69,
    y: 173.34,
    width: 83.02,
    height: 70.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.86625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.2,
    y: 208.805
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.69,
    y: 244.27,
    width: 83.02,
    height: 72.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.2,
    y: 280.57
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.69,
    y: 316.87,
    width: 83.02,
    height: 73.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.211666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.2,
    y: 353.505
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.69,
    y: 390.14,
    width: 83.02,
    height: 74.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.30111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.2,
    y: 427.495
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.69,
    y: 464.85,
    width: 83.02,
    height: 74.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.478
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.2,
    y: 502.24
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.69,
    y: 539.63,
    width: 83.02,
    height: 79.57,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.367142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.2,
    y: 579.415
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.69,
    y: 619.2,
    width: 83.02,
    height: 80.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.2,
    y: 659.6
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.72,
    y: 173.34,
    width: 86.71,
    height: 77.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.075,
    y: 212.28
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.43,
    y: 173.34,
    width: 89.37,
    height: 77.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.115,
    y: 212.28
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.8,
    y: 173.34,
    width: 94.2,
    height: 77.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.125714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.90000000000003,
    y: 212.28
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 173.34,
    width: 96.89,
    height: 77.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.979999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.445,
    y: 212.28
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595.89,
    y: 173.34,
    width: 104.11,
    height: 77.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.9449999999999,
    y: 212.28
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.72,
    y: 251.22,
    width: 102.08,
    height: 80.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.092
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.76,
    y: 291.45
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.72,
    y: 331.67,
    width: 102.08,
    height: 83.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.579090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.76,
    y: 373.355
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.72,
    y: 415.04,
    width: 102.08,
    height: 88.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.76,
    y: 459.08000000000004
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.72,
    y: 503.12,
    width: 102.08,
    height: 97.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.76,
    y: 552.085
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.72,
    y: 601.06,
    width: 102.08,
    height: 98.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.3675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.76,
    y: 650.53
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 251.22,
    width: 120.64,
    height: 98.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.481666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.12,
    y: 300.665
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.44,
    y: 251.22,
    width: 120.71,
    height: 98.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.795,
    y: 300.665
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.15,
    y: 251.22,
    width: 127.85,
    height: 98.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.481666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.0749999999999,
    y: 300.665
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 350.11,
    width: 104.35,
    height: 135.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.04375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.975,
    y: 417.805
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 485.5,
    width: 104.35,
    height: 214.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.907142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.975,
    y: 592.75
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.15,
    y: 350.11,
    width: 130.65,
    height: 207.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.33125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 500.47499999999997,
    y: 453.77
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.8,
    y: 350.11,
    width: 134.2,
    height: 207.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.9,
    y: 453.77
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.15,
    y: 557.43,
    width: 264.85,
    height: 142.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.960909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.575,
    y: 628.7149999999999
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1980);
export default __webpack_public_path__ + "static/media/1980.b96e33b2961daca5fc0ef56c366b36d9.svg";
export { ForwardRef as ReactComponent };